import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "brTag" })
export class BrTagPipe implements PipeTransform {
  transform(value: string): string {
    const regex = /(\d+\.\s)/g;
    return value.replace(regex, '<br>$1');

  }
}
